import { PluginObject, VueConstructor } from 'vue';
import Store from '@/store/index';
import { CurrentUser } from '@/shared';
import { initGtag } from '@/shared/helpers/init-gtag';

const store = () => Store;

export const DynamicPluginAdapter: PluginObject<null> = {
  install(vue: VueConstructor) {
    if (store()) {
      store().watch(() => (Store.getters['users/current'] as CurrentUser)?.isSuperUser, (isSuperUser: boolean) => {
        initGtag();
      }, {
        immediate: true,
      });
    }
  },
};
